import React from 'react';
import { Trash2, Edit2 } from 'react-feather';

const ActionMenu = ({ handleDelete, handleEdit }) => {
  return (
    <div className="JourneyBuilderActionMenu">
      <div className="JourneyBuilderActionMenu-options">
        <div
          className="JourneyBuilderActionMenu-option"
          onClick={handleDelete}
          onKeyDown={handleDelete}
        >
          <div className="d-f ai-c mt-4">
            <Trash2 className="JourneyBuilderActionMenu-icon" size={18} />
            Delete
          </div>
        </div>
        <div
          className="JourneyBuilderActionMenu-option"
          onClick={handleEdit}
          onKeyDown={handleEdit}
        >
          <div className="d-f ai-c mt-4">
            <Edit2 className="JourneyBuilderActionMenu-icon" size={18} />
            Edit
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionMenu;
